export const CUSTOMER_ROOT = 'customer/';

// Actions types
export const GET_ALL_CUSTOMERS = 'listAllCustomers';
export const GET_CUSTOMER_DETAILS = 'getCustomerProperties';
export const UPDATE_CUSTOMER = 'updateCustomer';
export const GET_ALL_OFFICES_BY_CUSTOMER = 'listAllOfficesByCustomer';
export const GET_ALL_SECTIONS_BY_OFFICE = 'getSections';
export const GET_OFFICE_DETAILS = 'getOfficeProperties';
export const UPDATE_OFFICE = 'updateOffice';
export const GET_ALL_REMINDERS_BY_CUSTOMER = 'listRemindersByCustomer';
export const CREATE_REMINDERS = 'createReminders';
export const DELETE_REMINDERS = 'deleteReminders';
export const GET_MANAGERS_BY_CUSTOMER = 'listManagersByCustomer';
export const SEARCH_MANAGER = 'searchManager';
export const CREATE_MANAGER = 'createManager';
export const DELETE_MANAGER = 'deleteManager';
export const UPDATE_MANAGER = 'updateManagerPrivileges';
export const UPLOAD_MANAGER_PRIVILEGES_FILE = 'loadManagerPrivileges';
export const UPLOAD_MANAGER_PRIVILEGES_FILE_UNIT = 'loadManagerOrgUnitPrivileges';
export const LIST_ORG_UNITS = 'listOrgUnits';
export const GET_MANAGER_PRIVILEGES = 'getManagerPrivileges';
export const UPDATE_MANAGER_PRIVILEGES = 'updateManagerPrivileges';
export const EXPORT_FORM_101 = 'runForm101PdfFilesExportJob';

// Mutations types
export const ALL_CUSTOMERS = 'allCustomers';
export const ALL_CUSTOMERS_ERRORS = 'allCustomersErrors';
export const CUSTOMER_DETAILS = 'customerDetails';
export const UPDATE_CUSTOMER_SETTINGS_MODAL = 'updateCustomerSettingsModal';
export const UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS = 'updateCustomerSettingsModalErrors';
export const ALL_OFFICES_BY_CUSTOMER = 'allOfficesByCustomer';
export const ALL_OFFICES_ERRORS = 'allOfficesErrors';
export const ALL_SECTIONS_BY_OFFICE = 'allSectionsByOffice';
export const OFFICE_DETAILS = 'officeDetails';
export const UPDATE_OFFICE_SETTINGS_MODAL = 'updateOfficeSettingsModal';
export const UPDATE_OFFICE_SETTINGS_MODAL_ERRORS = 'updateOfficeSettingsModalErrors';
export const SET_ALL_REMINDERS_BY_CUSTOMER = 'setAllRemindersByCustomer';
export const SET_OPEN_CREATE_REMINDERS_MODAL = 'setOpenCreateRemindersModal';
export const SET_OPEN_CREATE_REMINDERS_MODAL_ERRORS = 'setOpenCreateRemindersModalErrors';
export const CUSTOMER_RESET_STATE = 'customerResetState';
export const SET_MANAGERS_BY_CUSTOMER = 'setManagersByCustomer';
export const SET_MANAGER_TO_ADD = 'setManagerToAdd';
export const SET_MANAGER_TO_DELETE = 'setManagerToDelete';
export const SET_OPEN_DELETE_MANAGER_MODAL = 'setOpenDeleteManagerModal';
export const SET_OPEN_DELETE_MANAGER_MODAL_ERRORS = 'setOpenDeleteManagerModalErrors';
export const SET_MANAGER_TO_UPDATE = 'setManagerToUpdate';
export const SET_OPEN_UPDATE_MANAGER_MODAL = 'setOpenUpdateManagerModal';
export const SET_OPEN_UPDATE_MANAGER_MODAL_ERRORS = 'setOpenUpdateManagerModalErrors';
export const SET_OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL = 'setOpenUploadManagerPrivilegesFIleModal';
export const SET_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL_ERRORS = 'setOpenUploadManagerPrivilegesFIleModalErrors';
export const SET_OPEN_ADD_MANAGER_MODAL = 'setOpenAddManagerModal';
export const SET_OPEN_ADD_MANAGER_MODAL_ERRORS = 'setOpenAddManagerModalErrors';
export const SET_ORG_UNITS = 'setOrgUnits';
export const SET_MANAGER_PRIVILEGES = 'setManagerPrivileges';
export const SET_MANAGER_PRIVILEGE = 'setManagerPrivilege';
export const SET_EXPORT_FORM_101_REQUEST_ERRORS = 'setExportForm101RequestErrors';

// Getters types
export const SET_ALL_CUSTOMERS = 'setAllCustomers';
export const SET_ALL_CUSTOMERS_ERRORS = 'setAllCustomersErrors';
export const SET_CUSTOMER_DETAILS = 'setCustomerDetails';
export const SET_UPDATE_CUSTOMER_SETTINGS_MODAL = 'setUpdateCustomerSettingsModal';
export const SET_UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS = 'setUpdateCustomerSettingsModalErrors';
export const SET_ALL_OFFICES_BY_CUSTOMER = 'setAllOfficesByCustomer';
export const SET_ALL_OFFICES_ERRORS = 'setAllOfficesErrors';
export const SET_OFFICE_DETAILS = 'setOfficeDetails';
export const SET_ALL_SECTIONS_BY_OFFICE = 'setAllSectionsByOffice';
export const SET_ALL_SECTIONS_ERRORS = 'setAllSectionsErrors';
export const SET_UPDATE_OFFICE_SETTINGS_MODAL = 'setUpdateOfficeSettingsModal';
export const SET_UPDATE_OFFICE_SETTINGS_MODAL_ERRORS = 'setUpdateOfficeSettingsModalErrors';
export const ALL_REMINDERS_BY_CUSTOMER = 'allRemindersByCustomer';
export const OPEN_CREATE_REMINDERS_MODAL = 'openCreateRemindersModal';
export const OPEN_CREATE_REMINDERS_MODAL_ERRORS = 'openCreateRemindersModalErrors';
export const EXPORT_FORM_101_REQUEST_ERROR = 'exportForm101RequestErrors';
export const MANAGERS_BY_CUSTOMER = 'managersByCustomer';
export const MANAGER_TO_ADD = 'managerToAdd';
export const MANAGER_TO_DELETE = 'managerToDelete';
export const OPEN_DELETE_MANAGER_MODAL = 'openDeleteManagerModal';
export const OPEN_DELETE_MANAGER_MODAL_ERRORS = 'openDeleteManagerModalErrors';
export const MANAGER_TO_UPDATE = 'managerToUpdate';
export const OPEN_UPDATE_MANAGER_MODAL = 'openUpdateManagerModal';
export const OPEN_UPDATE_MANAGER_MODAL_ERRORS = 'openUpdateManagerModalErrors';
export const OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL = 'openUploadManagerPrivilegesFIleModal';
export const OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL_ERRORS = 'openUploadManagerPrivilegesFIleModalErrors';
export const OPEN_ADD_MANAGER_MODAL = 'openAddManagerModal';
export const OPEN_ADD_MANAGER_MODAL_ERRORS = 'openAddManagerModalErrors';
export const ORG_UNITS = 'orgUnits';
export const MANAGER_PRIVILEGES = 'managerPrivileges';
